module.exports = __webpack_public_path__ + "media/images/guides/random-04-a2989e360f6a3b5c4ca5742bc2988e92.svg";